<app-prescriptions-filters *ngIf="windowWidth >= mobileViewBreakPoint"></app-prescriptions-filters>
<app-mobile-prescriptions-filters *ngIf="windowWidth < mobileViewBreakPoint"></app-mobile-prescriptions-filters>
<app-prescriptions-table class="prescription-tabla-component" ></app-prescriptions-table>

